import { render, staticRenderFns } from "./JerseyFooter.vue?vue&type=template&id=46b2608e&scoped=true&"
import script from "./JerseyFooter.vue?vue&type=script&lang=ts&"
export * from "./JerseyFooter.vue?vue&type=script&lang=ts&"
import style0 from "./JerseyFooter.vue?vue&type=style&index=0&id=46b2608e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b2608e",
  null
  
)

export default component.exports